import { BffBrandType } from '@shared-components-web/gqlConstants';
import { BrandThemeConfig } from '@shared-components-web/types';

const contentfulEnvironmentSuffix = process.env.CONTENTFUL_ENVIRONMENT_ID
	? `/environments/${process.env.CONTENTFUL_ENVIRONMENT_ID}`
	: '';

const CONTENTFUL_GRAPHQL_URL = `https://graphql.contentful.com/content/v1/spaces/${
	process.env.CONTENTFUL_SPACE_ID as string
}${contentfulEnvironmentSuffix}`;

const config: BrandThemeConfig = {
	name: 'Aspen Dental',
	logo: {
		dark: 'https://images.ctfassets.net/m8zwsu9tyucg/7jzYqWlL2Z1NyUWPgR7mpc/922ffe5db0d5cd28bcb42653e7d9a5e6/AspenLogoDark.svg',
		light: 'https://images.ctfassets.net/m8zwsu9tyucg/1OLI6iOYAFp0Mvqm46Yyor/8908782b135cb2d577fe727a536434b1/logo-aspendental-white.svg',
	},
	siteURL: 'https://www.lovet.com',
	siteURLStage: 'https://wwwstg.lovet.com',
	services: {
		prod: {
			CONTENTFUL_GRAPHQL_URL,
			BEFFE_GRAPHQL_URL: 'https://www.aspendental.com/api/bff',
			FORM_EVENTS_URL: 'https://api.teamtag.com/form/events',
			GOOGLE_MAP_ID: '38da7512ef94f433',
			GOOGLE_MAP_API_KEY: 'AIzaSyCuENOZNjwZYYxR3_bozM2KFZisqmGzGw0',
		},
		nonprod: {
			CONTENTFUL_GRAPHQL_URL,
			BEFFE_GRAPHQL_URL: 'https://wwwstg.aspendental.com/api/bff',
			FORM_EVENTS_URL: 'https://aspen-userevents.gcp.stage.aspendental.com/form/events',
			GOOGLE_MAP_ID: '350b123288b58d3f',
			GOOGLE_MAP_API_KEY: 'AIzaSyAaUVIgw39qGcXdLzZv1nqLI7_hgiO95LE',
		},
	},
	features: {
		redirects: [],
		rewrite: {},
		favIcons: {},
		sitemap: {
			additionalSitemapIndexes: [
				'https://www.aspendental.com/dentist/sitemap-index.xml',
				'https://www.aspendental.com/schedule-an-apointment/sitemap-index.xml',
				'https://www.aspendental.com/search/sitemap-index.xml',
			],
		},
		analytics: {
			enabled: true,
			inline: false,
			active: false,
			vwoAccountId: '613301',
			gtmId: 'GTM-NTW7353',
			facebookPixel: false,
			braze: {
				enabled: false,
				sdkKey: '',
				restApiKey: '',
				baseUrl: '',
				enableLogging: process.env.ENVIRONMENT_NAME !== 'prod',
			},
		},
		monitoring: {
			bugSnagApiKey: process.env.BUGSNAG_API_KEY || '575c3f1095887b41f64a344c480c1923',
		},
		header: {
			hideHeaderOnScroll: false,
		},
		chat: {
			enabled: false,
		},
		notFoundPage: {
			desktopBackgroundImage:
				'https://images.ctfassets.net/m8zwsu9tyucg/AxWVBlTbpeJHO04OOM3SR/4e3ed05d72259d8aeb71d6c6f4bcafdf/WellNow404.png?q=90&fit=fill&f=face&fm=webp',
			mobileBackgroundImage:
				'https://images.ctfassets.net/m8zwsu9tyucg/4NGVlzvau9wEqmZd5h1pBt/0bd600d7d7c0f569d31fa1848b631806/WellNow404_M.jpg?q=90&fit=fill&f=face&fm=webp',
		},
		livePreview: {
			local: 'https://local.aspendental.com:8443',
			stage: 'https://wwwstg.aspendental.com',
			prod: 'https://www.aspendental.com',
		},
		footer: {
			lite: false,
			alt: false,
			withSimpleLayout: false,
		},
		blogs: {
			root: '/dental-care-resources/',
		},
		migration: {
			paths: ['dental-care-resources'],
		},
		otherApps: {
			facilityDetailsBasePath: 'dentist',
			schedulingPath: 'schedule-an-appointment',
		},
		providers: {
			root: '/providers/',
		},
		facilityDetailsDefaultId: 'Default_LV',
		schema: {},
	},
	featureFlags: {
		featureList: [],
		salesForceEvergageScript: 'Off',
		providerHeroTheme: 'dark',
		showHeaderWithLocationNav: false,
		showMobileHeaderLocationBar: true,
		defaultToCdn: false,
		useFacilityBeffeDataSource: false,
		showProviderPageCtaInMeetOurStaff: false,
		loadFacilityReviewsFromBeffe: false,
		showReadMoreForBioInMeetOurStaff: false,
		transitionallyUseBeffe: true,
		useInlineOneTrust: false,
		useSessionStorageFacilityCode: false,
		withLeadingProviderAssociations: false,
		doNotIndexWholeSite: false,
		hideHeaderFacilityLocator: false,
		hideHeaderSchedulingButton: false,
		showHeaderNavigationMenu: false,
		enableProvidersSitemap: false,
		useGoogleMapAutocompleteSearch: false,
		fetchAllLocationsOnEmptyResults: false,
		hideProviderWithNoImage: false,
		useSimpleFindOfficeLink: false,
		enableFluidTypography: false,
		oneTrust: false,
		enableCcMarketingSourceTransformation: false,
	},
	schemaUrl: '',
	contentfulAppId: 'Book_An_Appointment',
	themeId: 'lovet',
	bffBrandType: BffBrandType.AspenDental,
	googleMapBusinessQuery: 'https://www.google.com/maps/search/?api=1&query=Aspen Dental, [address]',
};

export default config;
